module.exports = __webpack_public_path__ + "static/media/CT_2019_30450A_pdf.7a822e06.pdf";